import script from "./MediaPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaPicker.vue?vue&type=script&setup=true&lang=js"

import "./MediaPicker.vue?vue&type=style&index=0&id=146db20e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146db20e"]])

export default __exports__